import { render, staticRenderFns } from "./ManagementHero.vue?vue&type=template&id=bcf44fce&scoped=true&"
import script from "./ManagementHero.vue?vue&type=script&lang=ts&"
export * from "./ManagementHero.vue?vue&type=script&lang=ts&"
import style0 from "./ManagementHero.vue?vue&type=style&index=0&id=bcf44fce&prod&lang=css&"
import style1 from "./ManagementHero.vue?vue&type=style&index=1&id=bcf44fce&prod&lang=scss&"
import style2 from "./ManagementHero.vue?vue&type=style&index=2&id=bcf44fce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf44fce",
  null
  
)

export default component.exports